import { render, staticRenderFns } from "./goods_unit.vue?vue&type=template&id=6431705c&"
import script from "./goods_unit.vue?vue&type=script&lang=js&"
export * from "./goods_unit.vue?vue&type=script&lang=js&"
import style0 from "./goods_unit.vue?vue&type=style&index=0&id=6431705c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports